<!--
  时间：2024年10月9日 14:00:24
-->
<template>
  <div class="footer_nav">
    <!-- <img src="../assets/static/images/jj_footer_top.png" class="footer_top" v-if="show" alt=""> -->
    <div class="footer_top">
      <div class="w1440 h78 flex-box fwb colf fs20">
        <div class="flex-grow-1 f1">大厂直供 小狮优选</div>
        <div class="flex-grow-1 f2">品类丰富 甄选好品</div>
        <div class="flex-grow-1 f3">海量活动 优惠好价</div>
        <div class="flex-grow-1 f4">正品保证 优享服务</div>
      </div>
    </div>
    <div class="foot_link">
      <div class="pt30 w1400 flex bb">
        <div class="flex-grow-1 flex">
          <div class="w33 fs16">
            <div class="fwb col2b cd lh22 pb10">服务保障</div>
            <div class="mt15 col68 cd fs15 lh20">正品保证</div>
            <div class="mt15 col68 cd fs15 lh20">7*12h在线客服</div>
            <div class="mt15 col68 cd fs15 lh20">送货上门</div>
          </div>
          <div class="w33 fs16">
            <div class="fwb col2b cd lh22 pb10">协议规范</div>
            <router-link to="/ServiceDetail?id=2" class="mt15 col68 cursor fs15 lh20">隐私协议</router-link>
            <router-link to="/ServiceDetail?id=1" class="mt15 col68 cursor fs15 lh20">用户协议</router-link>
          </div>
          <div class="w33 fs16">
            <div class="fwb col2b cd lh22 pb10">使用说明</div>
            <router-link to="/NewLogin" class="mt15 col68 cursor fs15 lh20">新用户注册</router-link>
            <router-link to="/Purchase" class="mt15 col68 cursor fs15 lh20">采购流程</router-link>
            <router-link to="/HelpCenter" class="mt15 col68 cursor fs15 lh20">常见问题</router-link>
            <!-- <router-link to="/CustomerSer" class="mt15 col68 cursor fs15 lh20">联系我们</router-link> -->
          </div>
        </div>
        <div class="flex-box ml60">
          <div class="tc">
            <img :src="wxmini_code" class="w134" alt="">
            <div class="mt15 col68 fs14">小狮优选小程序</div>
          </div>
          <div class="tc ml45">
            <img :src="wxoffical_code" class="w134" alt="">
            <div class="mt15 col68 fs14">小狮优选公众号</div>
          </div>
        </div>
      </div>
      <div class="tc w1400 pt20 pb40">
        <div class="colb8 fs14 lh20 cursor">沪ICP备 10000000号</div>
        <div class="colb8 fs14 lh20 cursor">©2024-2030 小狮优选系统-版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: { type: Boolean, default: true },
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      wxmini_code: '',
      wxoffical_code: ''
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  created() {
    this.wxmini_code = this.$root.$data.config.app.wxmini_code;
    this.wxoffical_code = this.$root.$data.config.app.wxoffical_code;
    this.$bus.on("initSuccess", () => {
      let config = this.$root.$data.config.app;
      //this.qrcode = config.customer_qrcode;
      this.wxmini_code = config.wxmini_code;
      this.wxoffical_code = config.wxoffical_code;
    });
  },
  // 组件方法
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
    toDetail(index) {
      this.$router.push({ path: '/ServiceDetail', query: { id: index } });
    },
  },
};
</script>

<style lang="less" scoped>
.footer_top {
  width: 100%;
  background-color: #3D7EFE;
}

.h78 {
  height: 78px;
}

.foot_link {
  // width: 1920px;
  // height: 376px;
  background: #F3F3F3;
}

.w140 {
  width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 30px;
}

.bb {
  padding-bottom: 35px;
  border-bottom: 1px solid #DEDEDE;
}

.w33 {
  width: 33.3%;

  a {
    display: block;
  }
}

.col2b {
  color: #2b2b2b;
}

.col68 {
  color: #686868;
}

.w134 {
  width: 134px;
  height: auto;
}

.ml45 {
  margin-left: 45px;
}

.ml60 {
  margin-left: 60px;
}

.colb8 {
  color: #B8B8B8;
}

.f1,
.f2,
.f3,
.f4 {
  &::before {
    display: inline-block;
    vertical-align: middle;
    width: 40px;
    height: 40px;
    content: '';
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: 20px;
  }
}

.f1 {
  &::before {
    background-image: url('../assets/static/icon/jj_foot1.png');
  }
}

.f2 {
  &::before {
    background-image: url('../assets/static/icon/jj_foot2.png');
  }
}

.f3 {
  &::before {
    background-image: url('../assets/static/icon/jj_foot3.png');
  }
}

.f4 {
  &::before {
    background-image: url('../assets/static/icon/jj_foot4.png');
  }
}
.cd{
  cursor: default;
}
</style>
